<template>
  <el-dialog
    :title="meeting_id ? '编辑会诊' : '创建会诊'"
    :visible.sync="showCreatDialog"
    custom-class="take-dialog"
    width="334px">
    <el-dialog
      :visible.sync="showChooseDialog"
      append-to-body
      custom-class="take-dialog"
      title="选择成员"
      width="802px">
      <div class="choose-warp">
        <div class="choose-warp-left">
          <div class="choose-warp-left-nav">
            <div :class="meetingMemberType ? 'on' : ''" @click="meetingMemberType = true">本群成员</div>
            <div :class="meetingMemberType ? '' : 'on'" @click="meetingMemberType = false">其他导师</div>
          </div>
          <template v-if="meetingMemberType">
            <div class="choose-radio-all" @click="meetingMemberChoose('add')">
              <div :class="meetMembersCount.self ==  meetingMemberList.members.length? 'icon-yixuan':'icon-weixuan'"
                   class="radio iconfont"></div>
              <div>全选</div>
            </div>
            <div class="choose-radio-warp">
              <div v-for="item in meetingMemberList.members" class="choose-radio-line"
                   @click="meetingMemberChoose('self',item)">
                <div :class=" meetingOpt.joined_member_ids.indexOf(item.member_id) != -1 ? 'icon-yixuan':'icon-weixuan'"
                     class="radio iconfont"></div>
                <img v-if="item.member_headpic" :src="item.member_headpic">
                <img v-else alt="" class="member-default-img" src="@/assets/img/base/default.png">
                <div class="choose-radio-name">
                  <div>{{ item.member_name }}</div>
                  <div>{{ item.member_type_text }}</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="choose-radio-all" @click="meetingMemberChoose('add')">
              <div
                :class=" meetMembersCount.other ==  meetingMemberList.otherMentors.length ? 'icon-yixuan':'icon-weixuan'"
                class="radio iconfont"></div>
              <div>全选</div>
            </div>
            <div class="choose-radio-warp">
              <div v-for="item in meetingMemberList.otherMentors" class="choose-radio-line"
                   @click="meetingMemberChoose('self',item)">
                <div :class=" meetingOpt.joined_member_ids.indexOf(item.member_id) != -1 ? 'icon-yixuan':'icon-weixuan'"
                     class="radio iconfont"></div>
                <img v-if="item.member_headpic" :src="item.member_headpic" alt="">
                <img v-else alt="" class="member-default-img" src="@/assets/img/base/default.png">
                <div class="choose-radio-name">
                  <div>{{ item.member_name }}</div>
                  <div>{{ item.member_type_text }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="choose-warp-right">
          <div class="d-flex-between">
            <div>已选：{{ meetMembers.length }}人</div>
            <div @click="meetingMemberChoose('del')">全部清除</div>
          </div>
          <div class="choose-head-warp d-flex-warp">
            <div v-for="item in meetMembers" class="member-item">
              <img v-if="item.member_headpic" :src="item.member_headpic" alt="">
              <img v-else alt="" class="member-default-img2" src="@/assets/img/base/default.png">
              <div class="member-item-name">{{ item.member_name }}</div>
              <div class="member-item-site">{{ item.member_type_text }}</div>
              <div class="iconfont icon-pizhu-qingkonghuaban member-item-del"
                   @click="meetingMemberChoose('self',item)"></div>
            </div>
          </div>
          <div class="take-dialog-bottom">
            <div class="take-dialog-close" @click="confirmMeetMember('cancel')">取消</div>
            <div class="take-dialog-open" @click="confirmMeetMember">确定</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="creat-title">会诊病例<span class="require">*</span></div>
    <div v-if="caseDetailValue.sz_date" class="case-person case-person-on" @click="rePick">
      <img alt="" class="case-person-grade" src="@/assets/img/doctor-detail/B.png">
<!--      <img alt="" class="case-person-state" src="@/assets/img/doctor-detail/state-new.png">-->
      <div class="d-flex-between" style="align-items: center">
        <div class="case-person-name">{{ caseDetailValue.name }}
          <div
            v-if="caseDetailValue.show_red_dot"
            class="new-dot"></div>
        </div>
        <div class="case-person-info">{{ caseDetailValue.age_text }}</div>
      </div>
      <div class="case-person-info">{{ caseDetailValue.no }}</div>
      <div class="case-person-time-line">
        <div class="case-person-time">
          <img alt="" src="@/assets/img/doctor-detail/time-shouzhen.png">
          {{ caseDetailValue.sz_date.substring(0, 11) }}
        </div>
        <div v-if="caseDetailValue.new_date" class="case-person-time-split"></div>
        <div v-if="caseDetailValue.new_date" class="case-person-time">
          <img src="@/assets/img/doctor-detail/time-zuixin.png">
          {{ caseDetailValue.new_date.substring(0, 11) }}
        </div>
      </div>
      <div :class="caseDetailValue.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'"
           class="case-person-cycle package-tag">
        {{ caseDetailValue.confirm_first_case_type_text != '' ? caseDetailValue.confirm_first_case_type_text : caseDetailValue.first_case_type_name }}
      </div>
    </div>
    <div v-else class="case-person" @click="rePick">
        <div class="iconfont icon-xinjian"></div>
    </div>
    <Doctor ref="doctor" :patient_id.sync="caseDetailValue.id" @doctor="handleSelectDoctor"></Doctor>
    <Patient ref="patient" :doctor_id="meetingDoctor.id" :patient_id.sync="caseDetailValue.id"
             @patient="handleSelectPatient"/>
    <div class="creat-title">会诊时间<span class="require">*</span></div>
    <div class="creat-check-time">
      <el-date-picker
        v-model="checkDate"
        class="check-time-input"
        end-placeholder="结束时间"
        format="yyyy.MM.dd HH:mm"
        prefix-icon="none"
        range-separator="至"
        start-placeholder="开始时间"
        type="datetimerange"
        value-format="yyyy.MM.dd HH:mm"
        @change="checkDateChange">
      </el-date-picker>
      <div class="iconfont icon-rili"></div>
    </div>
    <div class="creat-title">会诊人员<span class="require">*</span></div>
    <div class="check-people-line">
      <div class="check-people-line-left">
        <div class="iconfont icon-xinzeng" @click="showChooseDialog = true"></div>
        <template v-for="(item,index) in confirmMeetMembers" v-if="index < 4">
          <img v-if="item.member_headpic" :src="item.member_headpic">
          <img v-else alt="" class="member-default-img" src="@/assets/img/base/default.png">
        </template>
      </div>
      <div class="check-people-line-right">共{{ meetingOpt.joined_member_ids.length }}人</div>
    </div>
    <div class="creat-title">情况概述</div>
    <el-input
      v-model="meetingOpt.remark"
      class="creat-textarea"
      maxlength="80"
      placeholder="请输入内容"
      show-word-limit
      type="textarea"
    >
    </el-input>
    <div class="take-dialog-bottom">
      <div class="take-dialog-close" @click="showCreatDialog = false">取消</div>
      <div class="take-dialog-open" @click="createMeeting">确定</div>
    </div>
  </el-dialog>
</template>

<script>
import {CheckMultipleCreate, CreateMeeting, GetMeetingInfo, GetMeetingMemberList, UpdateMeeting} from "@/http/api";
import Patient from "@/views/consumables/components/Patient";
import Doctor from "@/views/consultation_room/components/Doctor";

export default {
  name: "MeetingDialog",
  components: {Patient, Doctor},
  props: {
    caseDetailValue: null
  },
  data() {
    return {
      checkDate: [],
      meetingOpt: {
        patient_id: '',
        joined_member_ids: [],
        start_time: '',
        end_time: '',
        remark: ''
      },
      meetingMemberType: true,//true本群，false其它
      meetingMemberList: {
        members: [],
        otherMentors: []
      },
      showCreatDialog: false,//创建会诊弹窗开关
      showChooseDialog: false,//选择人员弹窗开关
      meetMembers: [],
      confirmMeetMembers: [],
      meetMembersCount: {
        self: 0,
        other: 0
      },
      meetingDoctor: {},
      meeting_id: null,
      meetingData: {}
    }
  },
  mounted() {
    this.initCreateMeetingDate()
  },
  methods: {
    initCreateMeetingDate() {
      let checkDateTime = [new Date().getTime() + 1800000, new Date().getTime() + 3600000]
      this.checkDate[0] = new Date(checkDateTime[0]).toLocaleDateString().replaceAll('/', '.') + ' ' + new Date(checkDateTime[0]).toLocaleTimeString().substring(0, 5)
      this.checkDate[1] = new Date(checkDateTime[1]).toLocaleDateString().replaceAll('/', '.') + ' ' + new Date(checkDateTime[1]).toLocaleTimeString().substring(0, 5)
    },
    refreshMeetingMembers() {
      this.meetingOpt = {
        patient_id: '',
        joined_member_ids: [],
        start_time: '',
        end_time: '',
        remark: ''
      }
      this.meetingMemberList = {
        members: [],
        otherMentors: []
      }
      this.meetMembers = []
      this.confirmMeetMembers = []
      this.meetMembersCount = {
        self: 0,
        other: 0
      }
    },
    rePick(){
      if(!this.meeting_id)  this.$refs.doctor.openDialog()
    },
    checkDateChange(val) {
      this.checkDate = val
    },
    handleSelectPatient(item) {
      this.caseDetailValue = item
      this.openCreateMeeting()
    },
    handleSelectDoctor(item) {
      this.meetingDoctor = item
      this.$nextTick(() => {
        this.$refs.patient.openDialog()
        this.$refs.patient.getList(item.id)
      })

    },
    //会议相关接口
    openCreateMeeting(data) {
      //初始化聊天人员
      this.refreshMeetingMembers()
      if (data) this.caseDetailValue = data
      if (this.caseDetailValue.id) {
        CheckMultipleCreate({patient_id: this.caseDetailValue.id}).then(res => {
          if (res.data.is) {
            this.$confirm('该病例三个月内已进行会诊 是否继续创建会诊', '温馨提示', {
              confirmButtonText: '继续创建',
              cancelButtonText: '暂不创建',
              type: 'warning'
            }).then(() => {
              this.createMeetingPrepare()
            }).catch(() => {
              this.showCreatDialog = false
            });
          } else {
            this.createMeetingPrepare()
          }
        })
      } else {
        this.showCreatDialog = true
        this.initCreateMeetingDate()

      }
    },
    createMeetingPrepare() {
      this.showCreatDialog = true
      GetMeetingMemberList({patient_id: this.caseDetailValue.id}).then(res => {
        this.meetingMemberList = res.data
        if (!this.meeting_id) {
          res.data.members.forEach(item => {
            if (item.member_type_text != '医生') this.meetingMemberChoose('self', item)
          })
          this.confirmMeetMember()
        }
      })
      this.meetMembers = JSON.parse(JSON.stringify(this.confirmMeetMembers))
    },
    //回显数据
    editMeetDialog(id) {
      this.meeting_id = id
      this.refreshMeetingMembers()
      this.createMeetingPrepare()
      GetMeetingInfo({id: id}).then(res => {
        this.meetingData = res.data
        this.checkDate = [res.data.start_time2, res.data.end_time2]
        this.meetingOpt.remark = res.data.remark
        GetMeetingMemberList({patient_id: this.caseDetailValue.id, meeting_id: id}).then(res2 => {
          res2.data.members.forEach(item => {
            if(item.is_in_meeting) this.meetingMemberChoose('self', item)
          })
          res2.data.otherMentors.forEach(item => {
            if(item.is_in_meeting) this.meetingMemberChoose('self', item)
          })
          this.confirmMeetMember()
        })
      })
    },
    meetingMemberChoose(type, item) {
      let list = this.meetMembers
      if (item) {
        let i = list.findIndex(v => v.member_id == item.member_id)
        if (i == -1) {
          if (type != 'del') {
            this.meetMembers.push(item)
            this.meetingOpt.joined_member_ids.push(item.member_id)
            if (this.meetingMemberType) this.meetMembersCount.self += 1
            else this.meetMembersCount.other += 1
          }
        } else {
          if (type != 'add' && item.member_id != this.caseDetailValue.mentor_id) {
            this.meetMembers.splice(i, 1)
            this.meetingOpt.joined_member_ids.splice(i, 1)
            if (this.meetingMemberType) this.meetMembersCount.self -= 1
            else this.meetMembersCount.other -= 1
          }
        }
      } else {
        if (this.meetingMemberType) {
          if (type == 'add' && this.meetMembersCount.self == this.meetingMemberList.members.length) {
            this.meetingMemberList.members.forEach(val => {
              this.meetingMemberChoose('del', val)
            })
          } else {
            this.meetingMemberList.members.forEach(val => {
              this.meetingMemberChoose(type, val)
            })
            this.meetingMemberList.otherMentors.forEach(val => {
              this.meetingMemberChoose(type, val)
            })
          }
        } else {
          if (type == 'add' && this.meetMembersCount.other == this.meetingMemberList.otherMentors.length) {
            this.meetingMemberList.members.forEach(val => {
              this.meetingMemberChoose('del', val)
            })
          } else {
            this.meetingMemberList.members.forEach(val => {
              this.meetingMemberChoose(type, val)
            })
            this.meetingMemberList.otherMentors.forEach(val => {
              this.meetingMemberChoose(type, val)
            })
          }
        }
      }
    },
    confirmMeetMember(type) {
      this.showChooseDialog = false
      this.meetingOpt.joined_member_ids = []
      let _that = this
      if (type == 'cancel') {
        this.meetMembers = JSON.parse(JSON.stringify(this.confirmMeetMembers))
        this.confirmMeetMembers.forEach(item => {
          _that.meetingOpt.joined_member_ids.push(item.member_id)
        })
        console.log(_that.confirmMeetMembers)
        console.log(_that.meetingOpt.joined_member_ids)
      } else {
        this.confirmMeetMembers = JSON.parse(JSON.stringify(this.meetMembers))
        this.meetMembers.forEach(item => {
          _that.meetingOpt.joined_member_ids.push(item.member_id)
        })
      }

    },
    createMeeting() {
      let toast = ''
      if (!this.meetingOpt.joined_member_ids.length) toast = '请选择会诊人员'
      else if (!this.checkDate.length) toast = '请选择会诊时间'
      if (toast != '') {
        this.$message({
          type: 'error',
          message: toast
        })
        return false
      }
      this.showCreatDialog = false
      this.meetingOpt.patient_id = this.caseDetailValue.id
      this.meetingOpt.start_time = this.checkDate[0]
      this.meetingOpt.end_time = this.checkDate[1]
      if (this.meeting_id) {
        this.meetingOpt.id = this.meeting_id
        UpdateMeeting(this.meetingOpt).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '编辑成功'
            })
            this.$emit('EditOk')
          } else {
            this.$message({
              type: 'error',
              message: res.message[0]
            })
          }
        })
      } else {
        CreateMeeting(this.meetingOpt).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '创建成功'
            })
            this.$emit('createOk')
          } else {
            this.$message({
              type: 'error',
              message: res.message[0]
            })
          }
        })
      }

    }
  }
}
</script>

<style scoped src="../../../assets/css/case.css">
</style>
<style scoped src="../../../assets/css/doctor-detail.css">
</style>
<style>
.creat-check-time input {
  border: none;
  padding: 0 !important;
  height: 38px;
  color: #000000;
  text-align: left !important;
  width: 110px !important;
}

.creat-check-time .check-time-input {
  flex: 1;
  border: none;
  padding: 0;
}

.creat-check-time .check-time-input .el-input__icon {
  display: none;
}

.creat-check-time .el-date-editor .el-range-separator {
  line-height: unset;
  width: fit-content;
}
.creat-textarea textarea{
  height: 88px;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  padding: 6px 10px;
  resize: none;
}
</style>
